module.exports = __webpack_public_path__ + "static/media/rfbased1.fa911cbc.jpg";